"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.grade.title': 'Actualizar Cuenta',
    'user.grade.free': 'Gratis',
    'user.grade.basic': 'Básico',
    'user.grade.pro': 'Pro',
    'user.grade.ultra': 'Ultra',
};
